module.exports = __webpack_public_path__ + "static/media/1_A1_06.680caa19.png";